import script from "./BeInTrend.vue?vue&type=script&lang=ts&setup=true"
export * from "./BeInTrend.vue?vue&type=script&lang=ts&setup=true"

import "./BeInTrend.vue?vue&type=style&index=0&id=fa63b6c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa63b6c4"]])

export default __exports__